export default "__VITE_ASSET__DnPbVEKi__"